import React, { Children } from 'react';
import { motion } from 'framer-motion';
const tomes = [{
  color: '#FFCBA4',
  label: 'Atención & Concentración'
}, {
  color: '#FFB5C5',
  label: 'Lectoescritura Inclusiva'
}, {
  color: '#A8E6CF',
  label: 'Lenguaje & Comunicación'
}, {
  color: '#D4B5E8',
  label: 'Emociones & Habilidades Sociales'
}, {
  color: '#B5D8F5',
  label: 'Matemática & Lógica'
}, {
  color: '#FFAB91',
  label: 'Caja de Herramientas Inclusiva'
}];
const features = ['Para TEA y TDAH', 'Listo para imprimir', 'Adaptaciones por edad', 'Docentes y familias'];
const stats = [{
  value: '+1.000',
  label: 'familias'
}, {
  value: '6+6',
  label: 'tomos+bonos'
}, {
  value: '4.9/5',
  label: 'calificación'
}, {
  value: '🇦🇷',
  label: 'Argentina'
}];
export function SolutionSection() {
  return <section className="w-full bg-[#EAF6F0] py-16 sm:py-24 px-4" data-id="element-201">
      <div className="max-w-3xl mx-auto text-center" data-id="element-202">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 border border-[#F5C84B]/40 bg-white text-[#F5A04B] font-bold text-xs sm:text-sm px-5 py-2 rounded-full mb-8 tracking-wide shadow-sm" data-id="element-203">
          🏆 EL SISTEMA INCLUSIVO MÁS COMPLETO PARA DOCENTES Y FAMILIAS
        </motion.div>

        {/* Title block */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mb-10" data-id="element-204">
          {/* Brand name with decorative lines */}
          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-205">
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-[#F5C84B]/50" data-id="element-206" />
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-[#F5A04B] tracking-widest uppercase" data-id="element-207">
              💛 ITERAPRO™
            </h2>
            <div className="h-px flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-[#F5C84B]/50" data-id="element-208" />
          </div>

          <h3 className="text-xl sm:text-2xl md:text-3xl font-black text-[#3D3935] mb-6 tracking-wide" data-id="element-209">
            MEGA PACK INCLUSIVO INFANTIL™
          </h3>

          {/* Key value prop */}
          <div className="bg-white border border-[#EFE3D4] rounded-xl px-5 py-4 max-w-lg mx-auto mb-5 shadow-sm" data-id="element-210">
            <p className="text-[#3D3935] text-base sm:text-lg font-bold leading-snug mb-3" data-id="element-211">
              Todo organizado. Todo listo. Todo pensado para acompañar mejor.
            </p>
            <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-212">
              {['🧠 Atención', '📚 Lectoescritura', '🎨 Estimulación', '😊 Emociones', '🧩 Habilidades sociales', '🔤 Lenguaje', '🔢 Números y lógica', '🎯 Concentración'].map(tag => <span key={tag} className="text-[#8B7E76] text-[11px] sm:text-xs font-bold bg-[#FFF8F0] border border-[#EFE3D4] px-2.5 py-1 rounded-md" data-id="element-213">
                  {tag}
                </span>)}
            </div>
          </div>

          {/* Funciona desde hoy callout */}
          <p className="text-[#F5A04B] font-black text-sm sm:text-base tracking-wide" data-id="element-214">
            ⚡ Funciona desde el primer día
          </p>
        </motion.div>

        {/* Stats row */}
        <motion.div className="grid grid-cols-4 gap-3 max-w-md mx-auto mb-12" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} data-id="element-215">
          {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-216">
              <p className="text-[#3D3935] text-xl sm:text-2xl font-black leading-none mb-1" data-id="element-217">
                {stat.value}
              </p>
              <p className="text-[#8B7E76] text-[10px] sm:text-xs font-bold uppercase tracking-wider" data-id="element-218">
                {stat.label}
              </p>
            </div>)}
        </motion.div>

        {/* Tomes grid */}
        <div className="relative mx-auto mb-14 max-w-lg" data-id="element-219">
          <motion.div className="grid grid-cols-3 sm:grid-cols-6 gap-2.5 sm:gap-3" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.08
            }
          }
        }} data-id="element-220">
            {tomes.map((tome, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              y: 20,
              scale: 0.9
            },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
              transition: {
                duration: 0.4,
                ease: 'easeOut'
              }
            }
          }} className="aspect-[3/4] rounded-xl shadow-md flex items-end justify-center pb-3 px-1.5 relative overflow-hidden group cursor-default" style={{
            backgroundColor: tome.color,
            border: '2px solid rgba(255,255,255,0.5)'
          }} data-id="element-221">
                {/* Shine overlay */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, transparent 50%)'
            }} data-id="element-222" />
                <span className="relative text-[#3D3935] text-[9px] sm:text-[10px] font-black text-center leading-tight" data-id="element-223">
                  {tome.label}
                </span>
              </motion.div>)}
          </motion.div>

          {/* Badge below tomes */}
          <motion.div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-[#F5C84B] text-[#3D3935] font-black text-[10px] sm:text-xs px-5 py-1.5 rounded-full whitespace-nowrap shadow-md border border-white/50" initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.5
        }} data-id="element-224">
            6 TOMOS COMPLETOS
          </motion.div>
        </div>

        {/* Feature tags */}
        <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-w-lg mx-auto" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} data-id="element-225">
          {features.map((feat, i) => <span key={i} className="bg-white border border-[#EFE3D4] text-[#3D3935] text-[11px] sm:text-xs font-bold px-3 py-2.5 rounded-lg text-center shadow-sm" data-id="element-226">
              ✅ {feat}
            </span>)}
        </motion.div>
      </div>
    </section>;
}